import { Control, Controller } from "react-hook-form";
import { Row, Spacer } from "../../components/Layout/Layout";
import TextInput from "../../ui-lib/components/Inputs/TextInput";
import useTranslations from "../../core/i18n/useTranslations";
import { IOrganizationDetails } from "../../core/api/organizations/types";

export const AddressRow = ({
  control,
}: {
  control: Control<IOrganizationDetails, any, IOrganizationDetails>;
}) => {
  const t = useTranslations();
  return (
    <>
      <Spacer size={16} />

      <Row align="start">
        <Controller
          name="address"
          control={control}
          render={({ field }) => (
            <TextInput
              label={t("Common:labels_address")}
              description={t("Organizations:address_example")}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
        <Spacer size={32} />
        <Controller
          name="postalCode"
          control={control}
          render={({ field }) => (
            <TextInput
              placeholder="000 00"
              label={t("Common:labels_postal_code")}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </Row>
    </>
  );
};
